import { VehicleDetailsResponse } from '../models/asset-details-response.model';

export const POWER_UNIT = 'HP';
export const WEIGHT_UNIT = 'kg';

// Cab type and chassis are displayed but not returned by this endpoint yet, so they are
// excluded - including them would mark every response incomplete.
export const TRACKED_VEHICLE_FIELDS: readonly (keyof VehicleDetailsResponse)[] = [
  'vin',
  'productionSequenceNumber',
  'dateOfManufacture',
  'modelYear',
  'countryOfManufacture',
  'make',
  'model',
  'bodyStyle',
  'axleConfiguration',
  'engine',
  'powerHp',
  'transmission',
  'grossVehicleWeight',
  'fuelType',
  'co2Output',
];
